export default function UpcomingPaymentsCard({ payments }) {
  const items = Array.isArray(payments) ? payments : []
  return (
    <article className="rounded-lg bg-surface-container-low p-6">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
          Upcoming Payments
        </h3>
        <span className="material-symbols-outlined text-sm text-on-surface-variant">payments</span>
      </div>

      <div className="space-y-4">
        {items.map((payment, index) => (
          <div key={`${payment.name}-${payment.amount}-${index}`} className="flex items-center justify-between">
            <div>
              <p className="text-sm font-bold">{payment.name}</p>
              <p className="text-[10px] font-bold uppercase text-on-surface-variant">{payment.tag}</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold">{payment.amount}</p>
              <p className={`text-[10px] font-bold ${payment.isUrgent ? 'text-error' : 'text-on-surface-variant'}`}>
                {payment.due}
              </p>
            </div>
          </div>
        ))}
      </div>
    </article>
  )
}
